import React, { Component } from 'react';
import { connect } from 'react-redux';

import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'

class ManagerTable extends Component {
  constructor(props){
    super(props);
  }

  render() {
    const { SearchBar } = Search

    return (
      <ToolkitProvider
        keyField="id"
        data={ this.props.data }
        columns={ this.props.columns }
        search
      >
        {
          props => (
            <div>
              <div className="row justify-content-end">
                <div className="manager-search-field">
                  <SearchBar { ...props.searchProps }/>
                </div>
              </div>
              <BootstrapTable
                classes="bg-white"
                tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
                cellEdit={ cellEditFactory({
                    mode: 'dbclick',
                    blurToSave: true,
                    afterSaveCell: this.props.updateCell,
                  })
                }
                striped
                hover
                condensed
                noDataIndication={<span className="no-data-indication"><i className="file alternate icon"></i>No records found.</span>}
                { ...props.baseProps }
              />
            </div>
          )
        }
      </ToolkitProvider>
    )
  }
}

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManagerTable);



// WEBPACK FOOTER //
// ./src/views/components/managerTable.js